var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"error"},[_c('div',{staticClass:"error-container"},[_c('div',{staticClass:"error-code"},[_vm._v("500")]),_c('div',{staticClass:"error-msg"},[_vm._v(" "+_vm._s(_vm.errors.msg)+" ")])])])
}
var staticRenderFns = []

export { render, staticRenderFns }